<template>
	<StandardModal
		open
		small
		:title="$t('chat_replychain_convert_to_thread_alert_title')"
		:confirmText="$t('chat_replychain_convert_to_thread_alert_confirm')"
		:confirmProps="{ primary: true, loading }"
		@confirm="onConfirm"
		@cancel="$emit('cancel')"
		@open="focusInput"
		ref="modal"
	>
		<div class="convert-modal-body">
			<div class="desc">
				{{ $t('chat_replychain_convert_to_thread_alert_message') }}
			</div>
			<FormItem :label="$t('chat_thread_name_label_optional')">
				<Input
					v-model="title"
					ref="nameInput"
					autoFocus
					:placeholder="effectiveDefaultTitle"
					:maxlength="THREAD_TITLE_MAX_LENGTH"
				/>
			</FormItem>
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal, FormItem, Input } from '@/components/common'
import { createThread } from '@/api/thread'
import { THREAD_TITLE_MAX_LENGTH } from '@/helpers/utils'

export default {
	name: 'ConvertToThreadModal',
	components: { StandardModal, FormItem, Input },
	props: {
		bubbleId: { type: Number, required: true },
		sourceMessageId: { type: Number, required: true },
		defaultTitle: { type: String, default: '' },
	},
	emits: ['cancel', 'success'],
	computed: {
		effectiveDefaultTitle() {
			return this.defaultTitle || this.$t('chat_thread_default_title')
		},
	},
	data() {
		return {
			title: '',
			loading: false,
			THREAD_TITLE_MAX_LENGTH,
		}
	},
	methods: {
		focusInput() {
			this.$refs.nameInput?.focus()
		},
		async onConfirm() {
			this.loading = true
			try {
				const thread = await createThread(this.bubbleId, {
					title: this.title.trim() || this.effectiveDefaultTitle,
					source_message_id: this.sourceMessageId,
					convert_reply_chain: true,
				})
				this.$emit('success', thread)
			} catch (e) {
				console.error('Failed to convert to thread', e)
				this.$refs.modal.$alert.error(this.$t('common_api_error_save'))
				this.loading = false
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.convert-modal-body {
	padding: 24px 62px;
	.desc {
		font-size: 16px;
		color: var(--neutral-700);
		margin: 0 0 24px;
		text-align: center;
		font-family: Avenir-Medium;
	}
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.convert-modal-body {
		.desc {
			color: var(--neutral-800);
		}
	}
}
</style>
